const API_GATEWAY = 'https://banca.monex.com.mx';
const API_GATEWAY_WS = 'wss://banca.monex.com.mx'

export const environment = {
  production: true,
  homeUrl:`${API_GATEWAY}/nueva-banca-digital`,
  apiBanksUrl: `${API_GATEWAY}/api/receivers/banks`,
  apiDestinatarioNacionalUrl: `${API_GATEWAY}/api/receivers/nacional`,
  apiDestinatario: `${API_GATEWAY}/api/receivers`,
  apiTokenUrl: `${API_GATEWAY}/api/tokens`,
  apiCatalogsUrl: `${API_GATEWAY}/api/catalogs`,
  apiTargetUrl: API_GATEWAY,
  apiTargetSecure: false,
  apiUser: `${API_GATEWAY}/api/user`,
  webSocketUrl: `${API_GATEWAY}/api/tokens/ws`,
  remoteEntryPayments: `${API_GATEWAY}/payments/remoteEntryPayments.js`,
  remoteEntryUsers: `${API_GATEWAY}/users/remoteEntryUsers.js`,
  remoteEntryForwards: `${API_GATEWAY}/forwards/front/remoteEntry.js`,
  remoteEntryAccountManagement: `${API_GATEWAY}/account-management/remoteEntryAccountManagement.js`,
  bancaDigitalPage: 'https://bancadigital.monex.com.mx/PortalServicios/serviciosenlinea/view/template/ServiciosEnLinea.jsp',
  clientIdContabilidadProcAPI: '8e42ae10d4e341839db5a1e7db69d34f',
  clientSecretContabilidadProcAPI: '2433E6De4e7047C083f3b82a2B5d5fBe',
  remoteEntryConsultaDinamica: `${API_GATEWAY}/consulta-dinamica/remoteEntry.js`,
  wsConnection: API_GATEWAY_WS
};

